import type { Control } from "react-hook-form";
import {
	ClientPortfolioDomainEnum,
	type ProductCategoryKeyEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	CryptocurrencyEditFormInput,
	CryptocurrencyEditFormOutput,
} from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";

type CryptocurrencyEditFormFieldsProps = {
	control: Control<
		CryptocurrencyEditFormInput,
		unknown,
		CryptocurrencyEditFormOutput
	>;
	productCategory?: ProductCategoryKeyEnum | null;
};

export const CryptocurrencyEditFormFields = ({
	control,
	productCategory,
}: CryptocurrencyEditFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				productCategory={productCategory}
				domain={ClientPortfolioDomainEnum.Cryptocurrencies}
				namePlaceholder={t(
					Resources.Portfolio.AddCryptocurrency.Placeholders.name,
				)}
			/>
			<InvestmentToolsSection control={control} />
			<InvestmentAdditionalFields control={control} />
		</>
	);
};
